import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail } from 'lucide-react';
import './ContactSection.css';

const ContactSection = () => {
  const [formSubmitted, setFormSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormSubmitted(true);
    setTimeout(() => setFormSubmitted(false), 3000); // Reset after 3s
  };

  const handleMapClick = () => {
    window.open('https://maps.google.com?q=6+Myrdle+Street,+London,+England,+E1+1EU', '_blank');
  };

  return (
    <section id="support" className="contact-section">
      <div className="contact-container">
        <motion.h2
          className="contact-title"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          Hit Us Up
        </motion.h2>
        <div className="contact-stack">
          <motion.div
            className="contact-info-block"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <h3 className="contact-block-title">Drop By or Buzz Us</h3>
            <div className="info-stack">
              <motion.div className="info-item" whileHover={{ scale: 1.05 }}>
                <MapPin className="info-icon" size={28} />
                <span>6 Myrdle Street, London, E1 1EU</span>
              </motion.div>
              <motion.div className="info-item" whileHover={{ scale: 1.05 }}>
                <Phone className="info-icon" size={28} />
                <span>+44 7495 937969</span>
              </motion.div>
              <motion.div className="info-item" whileHover={{ scale: 1.05 }}>
                <Mail className="info-icon" size={28} />
                <span>keyurpat0712@gmail.com</span>
              </motion.div>
              <motion.div
                className="map-snap"
                onClick={handleMapClick}
                whileHover={{ scale: 1.03 }}
                transition={{ type: 'spring', stiffness: 300 }}
              >
                <span className="map-text">Swing By the Warehouse</span>
              </motion.div>
            </div>
          </motion.div>
          <motion.div
            className="contact-form-block"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            viewport={{ once: true }}
          >
            <h3 className="contact-block-title">Shout Your Needs</h3>
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-field">
                <label htmlFor="name" className="form-label">Name</label>
                <input type="text" className="form-input" id="name" placeholder="e.g., Dave the Dealer" required />
              </div>
              <div className="form-field">
                <label htmlFor="email" className="form-label">Email</label>
                <input type="email" className="form-input" id="email" placeholder="e.g., dave@tradeshop.co.uk" required />
              </div>
              <div className="form-field">
                <label htmlFor="message" className="form-label">What’s Up?</label>
                <textarea className="form-input form-textarea" id="message" placeholder="Need a pallet of crisps ASAP..." required />
              </div>
              <motion.button
                type="submit"
                className="form-btn"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Fire It Over
              </motion.button>
              {formSubmitted && (
                <motion.p
                  className="form-confirm"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.5 }}
                >
                  Sorted! We’ll hit you back soon.
                </motion.p>
              )}
            </form>
            <div className="chat-callout">
              <p>Can’t wait? Holler now!</p>
              <motion.a
                href="#chat"
                className="chat-link"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Chat Live
              </motion.a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;